import React, { useEffect, useState } from 'react';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import { HomeOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Breadcrumb, Pagination, ConfigProvider, BackTop } from 'antd';
import { Table, Space, Tooltip, Button } from 'antd';
import plPL from 'antd/lib/locale/pl_PL';
import TableDateRow from 'modules/layoutModule/components/TableDateRow/TableDateRow';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';
import TableDeleteRow from 'modules/layoutModule/components/TableDeleteRow/TableDeleteRow';
import {
  getGtwRequirements,
  removeSpecificGtwRequirementRequest,
} from '../requests/gtwRequests';
import useColumnSearch from '../../layoutModule/hooks/useColumnSearch';

export interface NewsCategoriesTableTypes {
  id: number;
  name: string;
  isActive: boolean;
  deleteAvailable: boolean;
}

const GtwRequirements = (): JSX.Element => {
  const [tableData, setTableData] = useState<NewsCategoriesTableTypes[]>([]);
  const [loading, toggleLoading] = useState<boolean>(true);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [tableKey, setTableKey] = useState(0);

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchedColumn('');
  };

  const confirmDelete = (id: number) => {
    removeSpecificGtwRequirementRequest(id).then((response) => {
      if (response) {
        downloadData();
      }
    });
  };

  const downloadData = () =>
    getGtwRequirements().then((response) => {
      if (response) {
        setTableData(response);
        toggleLoading(false);
      } else {
        toggleLoading(false);
      }
    });

  useEffect(() => {
    if (tableData.length === 0) {
      downloadData();
    }
  }, [tableData]);

  const columns = [
    {
      title: 'Nazwa',
      dataIndex: 'title',
      key: 'title',
      sorter: (a: { title: string }, b: { title: string }) =>
        a.title.localeCompare(b.title),
      ...useColumnSearch(
        'title',
        'Szukaj po nazwie',
        'Szukaj',
        'Resetuj',
        searchedColumn,
        setSearchedColumn,
        resetFilters
      ),
    },
    {
      title: 'Piktogram',
      dataIndex: 'fileImage1',
      key: 'fileImage1',
      render: (_: any, record: any) => (
        <TableDateRow
          record={record}
          field={TableDataRowTypes.GTW_REQUIREMENT}
          fieldName="fileImage1"
          size={68}
        />
      ),
    },
    {
      title: 'Aktywność',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '100px',
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.IS_ACTIVE} />
      ),
      sorter: (a: { isActive: number }, b: { isActive: number }) =>
        a.isActive - b.isActive,
      filters: [
        {
          text: 'TAK',
          value: 'isActive',
        },
        {
          text: 'NIE',
          value: 'isNotActive',
        },
      ],
      onFilter: (value: string, record: { isActive: boolean }) => {
        if (value === 'isActive') {
          return record.isActive;
        }
        return !record.isActive;
      },
    },
    {
      title: 'Akcje',
      dataIndex: 'operation',
      key: 'operation',
      width: 100,
      render: (_text: any, item: NewsCategoriesTableTypes) => (
        <Space
          size="middle"
          style={{ display: 'Flex', flexDirection: 'column' }}
        >
          <Tooltip title="Edytuj wpis">
            <Link to={`/gtw-requirements/${item.id}`}>
              <Button type="primary" shape="circle" icon={<EditOutlined />} />
            </Link>
          </Tooltip>
          <TableDeleteRow
            deleteAvailable={!item.isActive}
            onConfirm={() => confirmDelete(item.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Grunt to Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-requirements">Edycje warunki</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <Table
          // @ts-ignore
          columns={columns}
          dataSource={tableData}
          loading={loading}
          key={tableKey}
        >
          <Pagination />
        </Table>
        <BackTop />
      </ConfigProvider>
    </>
  );
};

export default GtwRequirements;
